import { render, staticRenderFns } from "./BuySkuCrowd.vue?vue&type=template&id=63325ba4&scoped=true"
import script from "./BuySkuCrowd.vue?vue&type=script&lang=js"
export * from "./BuySkuCrowd.vue?vue&type=script&lang=js"
import style0 from "./BuySkuCrowd.vue?vue&type=style&index=0&id=63325ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63325ba4",
  null
  
)

export default component.exports